/* eslint-disable import/prefer-default-export */
export const generateAnnotationKey = ({
    annotationType = 'note',
    entityId = null,
    dashboard = null,
    timestamp = Date.now()
}) => `${annotationType}:${entityId}:${dashboard}:${timestamp}`;

export const getDisplayCasedAnnotationType = type => ({
    NOTE: 'Note'
}[type]);



// WEBPACK FOOTER //
// ./src/helpers/annotations.js